import React from "react";
import "../assets/styles/career.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SmallercontCareer from "./SmallerContCareer";

// Import images
import emuImage from "../assets/images/emu.jpg";
import dihtLightImage from "../assets/images/diht_light.png";
import sim2realImage from "../assets/images/sim2real_video_thumbnail.jpg";
import ddppoLightImage from "../assets/images/ddppo_light.png";
import habitatImage from "../assets/images/habitat.png";
import splitnetLightImage from "../assets/images/splitnet_light.png";
import pacoLightImage from "../assets/images/paco_light.png";
import llama3Image from "../assets/images/llama3-06.png";
import llama3Parallelism from "../assets/images/llama3-parallelism.png"

const workTheme = createTheme({
  typography: {
    fontFamily: "Lato, sans-serif",
  },
});

export default function Work() {
  // Always use light theme images
  const getWorkItems = () => [
    {
      title: "Scaling Llama 3 Training with Efficient Parallelism Strategies",
      venue: "International Symposium on Computer Architecture (ISCA), 2025",
      imgSrc: llama3Parallelism,
      paperLink: "https://aisystemcodesign.github.io/papers/Llama3-ISCA25.pdf",
    },
    {
      title: "Llama 3",
      imgSrc: llama3Image,
      paperLink: "https://arxiv.org/abs/2407.21783",
      blogLink: "https://llama.meta.com/llama3/",
    },
    {
      title: "Emu: Enhancing Image Generation Models Using Photogenic Needles in a Haystack",
      venue: "ArXiv, 2023",
      imgSrc: emuImage,
      paperLink: "https://arxiv.org/abs/2309.15807",
      blogLink: "https://about.fb.com/news/2023/09/introducing-ai-powered-assistants-characters-and-creative-tools/",
    },
    {
      title: "Filtering, Distillation, and Hard Negatives for Vision-Language Pre-Training",
      venue: "Conference on Computer Vision and Pattern Recognition (CVPR), 2023",
      imgSrc: dihtLightImage,
      paperLink: "https://arxiv.org/abs/2301.02280",
      modelLink: "https://github.com/facebookresearch/diht",
    },
    {
      title: "PACO: Parts and Attributes of Common Objects",
      venue: "Conference on Computer Vision and Pattern Recognition (CVPR), 2023",
      imgSrc: pacoLightImage,
      paperLink: "https://arxiv.org/abs/2301.01795",
    },
    {
      title:
        "Sim2Real Predictivity: Does Evaluation in Simulation Predict Real-World Performance?",
      venue: "Robotics and Automation Letters (RA-L), 2020",
      venue2:
        "International Conference on Intelligent Robots and Systems (IROS), 2020",
      imgSrc: sim2realImage,
      paperLink: "https://arxiv.org/abs/1912.06321",
    },
    {
      title: "Decentralized Distributed PPO: Solving PointGoal Navigation",
      venue:
        "International Conference on Learning Representations (ICLR), 2020",
      imgSrc: ddppoLightImage,
      paperLink: "https://arxiv.org/abs/1911.00357",
      websiteLink: "https://wijmans.xyz/publication/ddppo-2019/",
    },
    {
      title: "Habitat: A Platform for Embodied AI Research",
      venue:
        "International Conference on Computer Vision (ICCV), 2019, Oral",
      venue2: "Best Paper Award Nominee, top 11 out of 4303 submissions",
      imgSrc: habitatImage,
      paperLink: "https://arxiv.org/abs/1904.01201",
      websiteLink: "https://aihabitat.org/",
    },
    {
      title:
        "SplitNet: Sim2Sim and Task2Task Transfer for Embodied Visual Navigation",
      venue: "International Conference on Computer Vision (ICCV), 2019",
      imgSrc: splitnetLightImage,
      paperLink: "https://arxiv.org/abs/1905.07512",
    },
  ];

  const renderWorkItems = () => {
    const items = getWorkItems();
    return items.map((item, index) => (
      <div className="work-item" key={index}>
        <img src={item.imgSrc} alt={item.title} className="work-image" />
        <div className="work-text-container">
          <h3>{item.title}</h3>
          {item.venue && <p><i>{item.venue}</i></p>}
          {item.venue2 && <p><i>{item.venue2}</i></p>}
          <div className="links-container">
            {item.websiteLink && (
              <a href={item.websiteLink} target="_blank" rel="noopener noreferrer" className="website-link">
                Website
              </a>
            )}
            {item.blogLink && (
              <a href={item.blogLink} target="_blank" rel="noopener noreferrer" className="website-link">
                Blog
              </a>
            )}
            {item.paperLink && (
              <a href={item.paperLink} target="_blank" rel="noopener noreferrer" className="paper-link">
                Paper
              </a>
            )}
            {item.modelLink && (
              <a href={item.modelLink} target="_blank" rel="noopener noreferrer" className="model-link">
                Models
              </a>
            )}
          </div>
        </div>
      </div>
    ));
  };

  return (
    <ThemeProvider theme={workTheme}>
      <SmallercontCareer>
        <div className="content-container">
          <section className="career-details">
            <div>
              <div className="career-header">
                <h1>Work</h1>
                {/* Theme toggle removed */}
              </div>
              <h4>
                Author:{" "}
                <a href="/" rel="noopener noreferrer" className="author-website-link">
                  Abhishek Kadian
                </a>
              </h4>
              <h4>Date: Oct 2026</h4>
              <div className="work-content">
                <div className="work-inner-container">
                  {renderWorkItems()}
                </div>
              </div>
            </div>
          </section>
        </div>
      </SmallercontCareer>
    </ThemeProvider>
  );
}
